function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
export const MIN_RELATED_AMOUNT = 1;
export const getPercentageDifference = (v1, v2) => 100 - v2 * 100 / v1;
export const spreadQuantities = (quantity, itemsToSpreadOver, allQuantityTo) => {
  let quantities;
  if (allQuantityTo !== undefined) {
    quantities = new Array(itemsToSpreadOver).fill(0);
    quantities[allQuantityTo] = quantity;
    return quantities;
  }
  const singleQuantity = Math.floor(quantity / itemsToSpreadOver);
  const firstQuantity = singleQuantity + quantity % itemsToSpreadOver;
  quantities = [firstQuantity];
  if (itemsToSpreadOver > 1) {
    quantities = [...quantities, ...new Array(itemsToSpreadOver - 1).fill(singleQuantity)];
  }
  return quantities;
};
export const prepareItemToShare = item => {
  const updatedItem = _objectSpread({}, item);
  delete updatedItem._id;
  delete updatedItem.deliveryTime;
  delete updatedItem.vendor;
  delete updatedItem.totalCharges;
  delete updatedItem.inHandDate;
  delete updatedItem.isNyTaxFree;
  delete updatedItem.variantInd;
  return updatedItem;
};